// extracted by mini-css-extract-plugin
export default {"container":"CardDepoimentos_container__ZYlzR","content":"CardDepoimentos_content__kB5Lt","description":"CardDepoimentos_description__Ti5Go"};